<span
  class="icomoon icomoon-info popover-trigger-icon icomoon-table-icon"
  (onShown)="onCustomerRecordPopoverShown()"
  [popover]="detailsPopover" triggers="mouseenter:mouseleave" container="body">
</span>

<ng-template #detailsPopover>
  <div class="font-weight-bold">{{ customerRecord.name }}</div>
  <div class="table-text-small"
       *ngIf="customerRecord.postalAddress && customerRecord.fieldModel.isManaged(CustomerRecordFieldType.POSTAL_ADDRESS_AND_INVOICE_ADDRESS_AND_NOTIFICATION_ADDRESS)">
    {{ Address.PostalAddressMapper.toString(customerRecord.postalAddress, config.postalAddressFormat) }}
  </div>
  <div
    *ngIf="customerRecord.externalId && customerRecord.fieldModel.isManaged(CustomerRecordFieldType.EXTERNAL_ID)"
    class="table-text-subtitle table-text-small mt-1">{{ 'COMMON_EXTERNAL_ID' | translate }}
  </div>
  <div
    *ngIf="customerRecord.externalId && customerRecord.fieldModel.isManaged(CustomerRecordFieldType.EXTERNAL_ID)">
    {{ customerRecord.externalId }}
  </div>

  <div
    *ngIf="customerRecord.fieldModel.isManaged(CustomerRecordFieldType.COMMENT)
    && customerRecord.comment.length > 0">
    <div
      class="table-text-subtitle table-text-small mt-1">{{ 'COMMON_COMMENT' | translate }}
    </div>
    <div>{{ customerRecord.comment }}</div>
  </div>

  <div
    *ngIf="customerRecord.fieldModel.isManaged(CustomerRecordFieldType.PHONE_NUMBERS)
    && customerRecord.phoneNumbers.length > 0">
    <div
      class="table-text-subtitle table-text-small mt-1">{{ 'CUSTOMER_RECORD_PHONE_NUMBERS' | translate }}
    </div>
    <div *ngFor="let phoneNumber of customerRecord.phoneNumbers">{{ phoneNumber.value.toIso() }}</div>
  </div>

  <div
    *ngIf="customerRecord.fieldModel.isManaged(CustomerRecordFieldType.EMAIL_ADDRESSES)
    && customerRecord.emailAddresses.length > 0">
    <div
      class="table-text-subtitle table-text-small mt-1">{{ 'CUSTOMER_RECORD_EMAIL_ADDRESSES' | translate }}
    </div>
    <div *ngFor="let emailAddress of customerRecord.emailAddresses">{{ emailAddress.value.toIso() }}</div>
  </div>

  <div *ngIf="customerRecord.ownerUsers && customerRecord.ownerUsers.length > 0">
    <div
      class="table-text-subtitle table-text-small mt-1">{{ 'CUSTOMER_RECORD_USERS' | translate }}
    </div>
    <div *ngFor="let user of customerRecord.ownerUsers">{{ user.itemName + ' (' + user.itemSubtitle + ')' }}</div>
  </div>

  <div *ngIf="customerRecord.ownerGroups && customerRecord.ownerGroups.length > 0">
    <div
      class="table-text-subtitle table-text-small mt-1">{{ 'CUSTOMER_RECORD_USER_GROUPS' | translate }}
    </div>
    <div *ngFor="let group of customerRecord.ownerGroups">{{ group.itemName }}</div>
  </div>

  <div *ngIf="customerRecord.taskRecordData && customerRecord.taskRecordData.taskRecordCount > 0">
    <div>
      <div
        class="table-text-subtitle table-text-small mt-1">{{ 'CUSTOMER_RECORD_RELATED_TASKRECORD_COUNT' | translate }}
      </div>
      <div>{{ customerRecord.taskRecordData.taskRecordCount }}</div>
    </div>
    <div *ngIf="customerRecord.taskRecordData.latestTaskRecordData">
      <div
        class="table-text-subtitle table-text-small mt-1">{{ 'CUSTOMER_RECORD_RELATED_TASKRECORD_LATEST' | translate }}
      </div>
      <div class="d-flex flex-column">
        <div>
          {{ customerRecord.taskRecordData.latestTaskRecordData.name }}
        </div>
        <div>{{ customerRecord.taskRecordData.latestTaskRecordData.creationTime.toUtcIsoString() | date: 'short' }}</div>
        <div *ngIf="config.assigneeWithUser && customerRecord.taskRecordData.latestTaskRecordData.assignee?.userData">
          {{ customerRecord.taskRecordData.latestTaskRecordData.assignee.userData.personName }}
            ({{ customerRecord.taskRecordData.latestTaskRecordData.assignee.userData.userName }})
        </div>
        <div class="row ml-0 mb-05 mt-05">
          <app-table-badge
            [badgeStyle]="customerRecord.taskRecordData.latestTaskRecordData.state.badgeStyle"
            [iconClass]="customerRecord.taskRecordData.latestTaskRecordData.state.iconClass"
            [breakWord]="true"
            [textKey]="customerRecord.taskRecordData.latestTaskRecordData.state.stringKey"
            [fontSize]="'small'">
          </app-table-badge>
        </div>
        <div *ngIf="customerRecord.taskRecordData.latestTaskRecordData.lastStateChangeLogWithMessage">
          <div *ngIf="customerRecord.taskRecordData.latestTaskRecordData.lastStateChangeLogWithMessage.message">
            <div class="text-truncate table-text-subtitle mt-05">{{ 'COMMON_COMMENT' | translate }}</div>
            <div
              class="break-word">{{ customerRecord.taskRecordData.latestTaskRecordData.lastStateChangeLogWithMessage.message }}
            </div>
            <div
              class="text-truncate">{{ customerRecord.taskRecordData.latestTaskRecordData.lastStateChangeLogWithMessage.logTime.toUtcIsoString() | date: 'short' }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>
